// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/exclamation-triangle.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/exclamation-triangle'

import { Icon, type IconComponentProps } from '../icon'

export const ExclamationTriangleIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
